import { LineOfBusiness, PolicyVersion } from '../models/domain.models';
import { addDays } from './rng';

export const LINE_PREFIX: Record<LineOfBusiness, string> = {
  auto: 'AUT', home: 'HOG', commerce: 'COM', liability: 'RC', 'personal-accident': 'AP', life: 'VID',
};

export function initialVersion(startDate: string, premium: number, subject: string): PolicyVersion {
  return { version: 1, effectDate: startDate, endorsementOid: null, premium, subject, status: 'active', endDate: addDays(startDate, 365) };
}
